import React, { useState } from 'react';
import Select from 'react-select';
import { Link } from 'react-router-dom';

const ExpenseModal = ({ isOpen, setIsOpen }) => {
    const [formData, setFormData] = useState({
        date: '',
        receipt: null,
        category: '',
        amount: '',
        invoice: '',
        notes: '',
        customerName: '',
    });

    const [categoryOptions, setCategoryOptions] = useState([
        { value: 'category1', label: 'Category 1' },
        { value: 'category2', label: 'Category 2' },
        { value: 'category3', label: 'Category 3' },
    ]);

    const [customerOptions, setCustomerOptions] = useState([
        { value: 'customer1', label: 'Customer 1' },
        { value: 'customer2', label: 'Customer 2' },
        { value: 'customer3', label: 'Customer 3' },
    ]);

    const [isAddCategoryModalOpen, setIsAddCategoryModalOpen] = useState(false);
    const [newCategory, setNewCategory] = useState({ name: '', description: '' });
    const [newCustomer, setNewCustomer] = useState({ name: '', contact: '' });

    if (!isOpen) return null;

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value,
        });
    };

    const handleFileChange = (e) => {
        setFormData({
            ...formData,
            receipt: e.target.files[0],
        });
    };

    const handleSelectChange = (selectedOption, action) => {
        setFormData({
            ...formData,
            [action.name]: selectedOption,
        });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
    };

    const handleAddCategory = () => {
        if (newCategory.name && newCategory.description) {
            setCategoryOptions([
                ...categoryOptions,
                { value: newCategory.name, label: newCategory.name },
            ]);
            setIsAddCategoryModalOpen(false); // Close the modal
            setNewCategory({ name: '', description: '' }); // Reset new category data
        }
    };

    return (
        <div className="custom-modal-overlay" onClick={() => setIsOpen(false)}>
            <div
                className="custom-modal-content"
                onClick={(e) => e.stopPropagation()} // Prevent closing on content click
            >
                <h2 className="oms-modal-title">Expense Details</h2>
                <form className="oms-modal-form" onSubmit={handleSubmit}>
                    <div className="oms-form-group">
                        <label htmlFor="date" className="oms-form-label">
                            Date
                        </label>
                        <input
                            type="date"
                            id="date"
                            name="date"
                            value={formData.date}
                            onChange={handleChange}
                        />
                    </div>
                    <div className="oms-form-group">
                        <label htmlFor="receipt" className="oms-form-label">
                            Attach Receipt (JPEG, PDF, Excel)
                        </label>
                        <input
                            type="file"
                            id="receipt"
                            name="receipt"
                            accept=".jpeg,.pdf,.xls,.xlsx"
                            onChange={handleFileChange}
                        />
                    </div>
                    <div className="oms-form-group">
                        <label htmlFor="category" className="oms-form-label">
                            Category
                        </label>
                        <Select
                            options={categoryOptions}
                            placeholder="Select category"
                            name="category"
                            value={formData.category}
                            onChange={(selectedOption) =>
                                handleSelectChange(selectedOption, { name: 'category' })
                            }
                        />
                        <button
                            type="button"
                            className="oms-add-button"
                            onClick={() => setIsAddCategoryModalOpen(true)}
                        >
                            Add new category
                        </button>
                    </div>
                    <div className="oms-form-group">
                        <label htmlFor="amount" className="oms-form-label">
                            Amount
                        </label>
                        <input
                            type="number"
                            id="amount"
                            name="amount"
                            placeholder="Enter amount"
                            value={formData.amount}
                            onChange={handleChange}
                        />
                    </div>
                    <div className="oms-form-group">
                        <label htmlFor="invoice" className="oms-form-label">
                            Invoice Number
                        </label>
                        <input
                            type="text"
                            id="invoice"
                            name="invoice"
                            placeholder="Enter invoice number"
                            value={formData.invoice}
                            onChange={handleChange}
                        />
                    </div>
                    <div className="oms-form-group">
                        <label htmlFor="notes" className="oms-form-label">
                            Notes
                        </label>
                        <textarea
                            id="notes"
                            name="notes"
                            placeholder="Enter any additional notes"
                            value={formData.notes}
                            onChange={handleChange}
                        />
                    </div>
                    <div className="oms-form-group">
                        <label htmlFor="customerName" className="oms-form-label">
                            Customer Name
                        </label>
                        <Select
                            options={customerOptions}
                            placeholder="Select customer"
                            name="customerName"
                            value={formData.customerName}
                            onChange={(selectedOption) =>
                                handleSelectChange(selectedOption, { name: 'customerName' })
                            }
                        />
                        <Link to='/add-customer-2'>
                            <button
                                type="button"
                                className="oms-add-button"
                            >
                                Add new customer
                            </button>
                        </Link>
                    </div>
                    <div className="oms-form-actions">
                        <button type="button" onClick={() => setIsOpen(false)}>
                            Cancel
                        </button>
                        <button type="submit">Submit</button>
                    </div>
                </form>
            </div>

            {/* Add New Category Modal */}
            {isAddCategoryModalOpen && (
                <div className="custom-modal-overlay" onClick={() => setIsAddCategoryModalOpen(false)}>
                    <div
                        className="custom-modal-content"
                        onClick={(e) => e.stopPropagation()} // Prevent closing on content click
                    >
                        <h2 className="oms-modal-title">Add New Category</h2>
                        <form className="oms-modal-form">
                            <div className="oms-form-group">
                                <label htmlFor="categoryName" className="oms-form-label">
                                    Category Name
                                </label>
                                <input
                                    type="text"
                                    id="categoryName"
                                    placeholder="Enter category name"
                                    value={newCategory.name}
                                    onChange={(e) => setNewCategory({ ...newCategory, name: e.target.value })}
                                />
                            </div>
                            <div className="oms-form-group">
                                <label htmlFor="categoryDescription" className="oms-form-label">
                                    Description
                                </label>
                                <input
                                    type="text"
                                    id="categoryDescription"
                                    placeholder="Enter category description"
                                    value={newCategory.description}
                                    onChange={(e) => setNewCategory({ ...newCategory, description: e.target.value })}
                                />
                            </div>
                            <div className="oms-form-actions">
                                <button type="button" onClick={() => setIsAddCategoryModalOpen(false)}>
                                    Cancel
                                </button>
                                <button type="save" onClick={handleAddCategory}>
                                    Save Category
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            )}
        </div>
    );
};

export default ExpenseModal;
